import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { TimeStampReportWrapper } from "../../components";

export default function TimeStampReportPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <TimeStampReportWrapper organization={organization} />
    </ModalProvider>
  );
}
